<template>
    <my-beauty v-if="user" :passUserRewardsAnswer="false" :user="user" />
</template>

<script setup>
    import MyBeauty from '../../components/MyBeauty.vue'
    defineProps({
        user: Object
    })
</script>